<template>
  <div class="container">
    <donut-page-title title="Archived Journeys" />
    <donut-table
      class="m-tx4"
      :headers="headers"
      :data="props.tags"
    >
      <template #journey="{ entry }"><div class="t">{{ entry.name }}</div></template>
      <template #messages="{ entry }"><div class="t">{{ messagesCopy(entry) }}</div></template>
      <template #sessions="{ entry }">
        <div class="f-sb f-ac">
          <div class="t">{{ sessionsCopy(entry) }}</div>
          <button v-tooltip="'Unarchive'" class="p-x1 inv" @click="openActivateModal(entry)"><i class="mi">unarchive</i></button>
        </div>
      </template>
    </donut-table>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';

  const props = defineProps({
    tags: { type: Array, default: () => [] },
  });
  const { commit } = useStore();

  const headers = [
    { label: 'Journey', key: 'journey', weight: 2 },
    { label: 'Messages', key: 'messages', weight: 1 },
    { label: 'New Hires / Participants', key: 'sessions', weight: 2 },
  ];

  const messagesCopy = (tag) => {
    if (tag.events_count === 1) return '1 message';
    return `${tag.events_count} messages`;
  };
  const sessionsCopy = (tag) => {
    const noun = tag.flow_type === 'onboarding' ? 'new hire' : 'participant';
    if (tag.sessions_count === 1) return `1 ${noun}`;
    return `${tag.sessions_count} ${noun}s`;
  };

  const openActivateModal = (tag) => {
    commit('updateModal', {
      visible: true,
      subcomponent: 'onboarding-tags-modals-activate',
      data: { tag },
    });
  };
</script>
